/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React from "react";
import get from "lodash/get";
import { BlankStory } from "../story-templates/blank";
import { BlankNoAdsStory } from "../story-templates/blank-no-ads";
import { VideoStory } from "../story-templates/video";
import { PhotoStory } from "../story-templates/photo";
import { LiveBlog } from "../story-templates/live-blog";
import { EditorialStory } from "../story-templates/editorial";
import { ColumnStory} from "../story-templates/column"
import { WowStory } from "../story-templates/wow";
import { NativeAdStory } from "../story-templates/native-ad";
import { OpinionStory } from "../story-templates/opinion";
import { number, object, shape, any, array } from "prop-types";
import { postVisitData } from "../utils/post-user-visit";

function StoryPageBase({ story, params, otherProp }) {
  postVisitData(story);
  //console.log("story template ", story["story-template"])
  if (story["story-template"] === "video") {
    return <VideoStory story={story} />;
  } else if (story["story-template"] === "photo") {
    return <PhotoStory story={story} />;
  } else if (story["story-template"] === "pkirjoitus") {
    return <EditorialStory story={story} />;
  } else if (story["story-template"] === "kolumni") {
    return <ColumnStory story={story} />;
  } else if (story["story-template"] === "natiivi") {
    return <NativeAdStory story={story} />;
  } else if (story["story-template"] === "wau-juttu") {
    return <WowStory story={story} />;
  } else if (story["story-template"] === "ei-mainoksia") {
    return <BlankNoAdsStory story={story} />;
  } else if ((story["story-template"] === "mielipide") || (story["story-template"] === "tiedotteet")) {
    return <OpinionStory story={story} />;
  } else if (story["story-template"] === "live-blog") {
    return <LiveBlog story={story} cardId={get(params, ["cardId"])} />
  } else {
    return <BlankStory story={story} />;
  }
}

StoryPageBase.propTypes = {
  index: number,
  story: object,
  otherProp: any,
};

export function StoryPage(props) {
  return <StoryPageBase {...props.data} />;
}


StoryPage.propTypes = {
  data: shape({
    story: object
  })
};
